export default "__VITE_ASSET__BKhVXO5R__"